import React from 'react';
import { Button, Icon, Table, Header, Popup, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const addedSPBasic = true;

const NoDataMessage = () => <p><br />Nema studijskih programa.</p>;

export default class StudyPrograms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],

            loading: true,
            addNewSP: false,
            confirmation: false,
            activeRole: '',

            results: []
        };

        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.archive = this.archive.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        this.getStudyPrograms(localStorage.getItem('orgUnitId'));
    }


    componentDidUpdate(prevState) {
        if (localStorage.getItem('addedSPBasic')) {
            if (localStorage.getItem('addedSPBasic') !== prevState.addNewSP) {
                this.getStudyPrograms(localStorage.getItem('orgUnitId'));
            }
        }
    }

    getStudyPrograms(orgUnitId) {
        let obj = {};
        axios.post(`study-programs/basic/${orgUnitId}`, { ...obj })
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el, studyProgramBasicName: el.studyProgramBasic.name
                    })),
                    loading: false
                });
                localStorage.removeItem('addedSPBasic');
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });
    }

    archive(id, optlock) {
        let archiveStudyProgram = {};

        if (id) archiveStudyProgram = { ...archiveStudyProgram, id };
        else archiveStudyProgram = { ...archiveStudyProgram, id: 0 };
        if (optlock) archiveStudyProgram = { ...archiveStudyProgram, optlock };
        archiveStudyProgram = { ...archiveStudyProgram };

        axios.put('study-programs/archive-basic', { ...archiveStudyProgram })
            .then(res => {
                this.getStudyPrograms(localStorage.getItem('orgUnitId'));
                toast('Studijski program je uspješno arhiviran.');
            })
            .catch(err => {
                toast('Došlo je do greške! Studijski program nije arhiviran.');
            });

        this.setState({ confirmation: false });
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results.filter(el => el.studyProgramBasic.archived !== true);
        }
        return this.state.data.filter(el => el.studyProgramBasic.archived !== true);
    }

    getResults(results) {
        this.setState({ results });
    }


    render() {
        const { activeRole } = this.props;
        if (this.state.loading && localStorage.getItem('orgUnitId')) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;

        return (
            <div>
                <Table celled selectable compact >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={10} >
                                <div style={{ paddingLeft: '30px' }}>
                                    <SearchTableData data={this.state.data.filter(el => el.studyProgramBasic.archived !== true)} getResults={this.getResults} filterItem={['studyProgramBasicName', 'description', 'enrollmentTerms', 'name', 'department']} />
                                </div>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width="1">
                                R. br.
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>
                                <Header as="h4">
                                    <Header.Content>
                                        Naziv studijskog programa (B/H/S)
                                    </Header.Content>
                                    <Header.Subheader>Naziv studijskog programa (EN)</Header.Subheader>
                                </Header>
                            </Table.HeaderCell>
                            {/*<Table.HeaderCell colSpan={3}>*/}
                            {/*    Naziv studijskog programa*/}
                            {/*</Table.HeaderCell>*/}
                            <Table.HeaderCell colSpan={2}>
                                Ciklus studija
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} width="2">
                                Napomena
                            </Table.HeaderCell>
                            {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') ? <Table.HeaderCell width="4" textAlign="center" colSpan={2}>
                                <Link to={{ pathname: '/osnovni-studijski-programi/kreiranje-smjera' }}>
                                    <Button
                                        color="blue"
                                        size="small"
                                        style={FiltersOnStyle}
                                        onClick={() => localStorage.setItem('addedSPBasic', addedSPBasic)}
                                    ><Icon className="add" />
                                        Kreiraj studijski program
                                    </Button>
                                </Link>
                            </Table.HeaderCell> : <Table.HeaderCell width="4" textAlign="center" colSpan={2}></Table.HeaderCell>}
                        </Table.Row>
                    </Table.Header>
                    {this.getDataToRender().length ?
                        <Table.Body> {this.getDataToRender().map((el, index) =>
                            (<Table.Row key={el.id}>
                                <Table.Cell verticalAlign="middle" width={1}>
                                    {index + 1}.
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.studyProgramBasicName} {el.studyProgramBasic.translations && el.studyProgramBasic.translations.map(e => (<div style={{ color: '#a6a4a1' }}>{e.name}<br /></div>))}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle"colSpan={2}>
                                    {el.studyProgramBasic.studyCycles.map(e => (<div>{e.displayName}<br /></div>))}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2} width="2">
                                    {el.studyProgramBasic.comment}
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle" width="4" colSpan={2}>
                                    {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') && <Link to={{ pathname: '/osnovni-studijski-programi/izmjena-i-detalji', state: { studyProgram: el, orgUnitId: localStorage.getItem('orgUnitId'), orgUnits: this.props.orgUnits } }}>
                                        <Popup
                                            content="Izmjena / detalji"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    color="green"
                                                    size="small"
                                                    circular
                                                    icon="pencil alternative"
                                                    onClick={() => { localStorage.setItem('addedSPBasic', addedSPBasic); }}
                                                >
                                                </Button>}
                                        >
                                        </Popup>
                                    </Link>}
                                    <Link to={{ pathname: '/osnovni-studijski-programi/implementacije', state: { id: el.studyProgramBasic.id, name: el.studyProgramBasic.name } }}>
                                        <Popup
                                            content="Implementacije"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    size="small"
                                                    icon="folder open"
                                                    circular
                                                    onClick={() => localStorage.setItem('studyCycles', JSON.stringify(el.studyProgramBasic.studyCycles.map(e => ({
                                                        key: e.id, value: e.id, text: e.displayName
                                                    }))))}
                                                >
                                                </Button>}
                                        >
                                        </Popup>
                                    </Link>

                                    { (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') ?
                                        this.state.confirmation === index ?
                                            <div>
                                                <h4>Jeste li sigurni?</h4>
                                                <Button.Group>
                                                    <Button
                                                        basic="true"
                                                        color="blue"
                                                        onClick={() => {
                                                            this.archive(
                                                                el.studyProgramBasic.id,
                                                                el.studyProgramBasic.optLock
                                                            );
                                                        }}
                                                    > DA</Button>
                                                    <Button
                                                        basic="true"
                                                        color="red"
                                                        onClick={() => { this.setState({ confirmation: false }); }}
                                                    >  NE

                                                    </Button>
                                                </Button.Group>
                                            </div>
                                            : <Popup
                                                content="Arhiviraj"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        color="red"
                                                        size="small"
                                                        circular
                                                        icon="archive"
                                                        onClick={() => { this.setState({ confirmation: index }); }}
                                                    >
                                                    </Button>}
                                            >
                                            </Popup>
                                        : ''

                                    }

                                </Table.Cell>

                            </Table.Row>))}
                        </Table.Body>
                        : <Table.Body>
                            <Table.Row>
                                <Table.Cell colSpan={4}>
                                    <NoDataMessage />
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>}
                </Table>

                <ToastContainer hideProgressBar />
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/StudyPrograms.js